import { createContext, useContext, useEffect, useState } from 'react';
import { api, getSession, onSession, setSession } from '../api/client.js';
import i18n from '../i18n/index.js';

const Ctx = createContext(null);

/** Session = Brightivity sign-in (own /auth on brightivity.dev). Confirmed with /auth/me on load. */
export function SessionProvider({ children }) {
  const [session, setS] = useState(getSession);
  const [checked, setChecked] = useState(!getSession());
  useEffect(() => onSession(setS), []);
  useEffect(() => {
    const s = getSession();
    if (!s) return;
    // Every load re-checks the account the way the desktop does at launch (/user/features): a license that
    // was reset or revoked signs out with the reason shown on the welcome screen.
    api('/auth/me').then((r) => {
      if (r.ok) setSession({ ...s, ...r.data, userId: r.data.userId, email: r.data.email, name: r.data.name });
      else if (r.status === 401 || r.status === 403) {
        if (r.status === 403 && r.data && r.data.error) { try { localStorage.setItem('bv.logoutReason', r.data.error); } catch { /* blocked */ } }
        else if (r.status === 401) { try { localStorage.setItem('bv.logoutReason', i18n.t('bv:auth.sessionInvalid')); } catch { /* blocked */ } }
        setSession(null);
      }
      setChecked(true);
    });
  }, []);
  const value = {
    session,
    checked,
    signedIn: !!(session && session.token),
    signOut: () => setSession(null),
    signIn: (token, user) => {
      setSession({ token, userId: user.id, email: user.email, name: user.name });
      // Fill in the account claims (license, school, approver, onboarding) right away.
      api('/auth/me').then((r) => { if (r.ok) setSession({ token, ...r.data, userId: r.data.userId, email: r.data.email, name: r.data.name }); });
    },
  };
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}
export const useSession = () => useContext(Ctx);

export function initialsFor(s) {
  const src = (s && (s.name || s.email)) || '';
  const parts = src.replace(/@.*/, '').split(/[\s._-]+/).filter(Boolean);
  return ((parts[0] || '?')[0] + (parts[1] ? parts[1][0] : '')).toUpperCase();
}
